module.exports = __webpack_public_path__ + "media/honey-icons/icon-forward-video-c5f8f30f.svg";